<script lang="ts">
  import { onMount } from "svelte";
  import { browser } from "$app/environment";

  let fontsLoaded = false;

  function loadCSS(href: string) {
    if (!browser) return;
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    document.head.appendChild(link);
  }

  function loadFonts() {
    if (fontsLoaded) return;
    fontsLoaded = true;

    loadCSS("/fonts/geist-sans/font.css");
    loadCSS("https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&display=swap");
  }

  onMount(() => {
    requestAnimationFrame(loadFonts);

    return () => {};
  });
</script>

<svelte:head>
  <link rel="preconnect" href="https://fonts.googleapis.com" />
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
</svelte:head>
